import { render, staticRenderFns } from "./randomTitleGeneratorForm.vue?vue&type=template&id=2229c79a&"
import script from "./randomTitleGeneratorForm.vue?vue&type=script&lang=js&"
export * from "./randomTitleGeneratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports